module.exports = __webpack_public_path__ + "static/media/Background.40ddc59b.webp";